



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { User } from '@/models/User';
import { BButton, BOverlay } from 'bootstrap-vue';
import BaseCard from '@/components/BaseCard.vue';
import ModalUserConfig from './modals/UserConfig.vue';
import ModalUserRemove from './modals/UserRemove.vue';

@Component({
    name: 'BaseUser',
    components: {
        'base-card': BaseCard,
        'b-button': BButton,
        'b-overlay': BOverlay,
        'modal-user-config': ModalUserConfig,
        'modal-user-remove': ModalUserRemove,
    },
    computed: mapGetters({
        organisation: 'organisation/organisation',
        isOwner: 'organisation/isOwner',
        account: 'account/account',
        users: 'users/all',
    }),
})
export default class BaseUser extends Vue {
    error: string = '';
    updating: boolean = false;

    @Prop() user!: User;
}
